import React from 'react';

export default class BreadCrumbs extends React.Component {
  constructor(props) {
    super(props);
  }

  render = () => {
    const breadcrumbs = this.props.breadcrumbs.itemListElement || [];

    return (
      <div id="breadcrumbs-bar" className="breadcrumbs-bar">
        <div className="wrapper">
          <ul>
            {breadcrumbs.map((breadcrumb, index) => {
              const isLastElement = index + 1 === breadcrumbs.length;
              const url = breadcrumb.item['@id'];
              const name = breadcrumb.item.name;

              return !isLastElement ? (
                <li key={index}>
                  <span>
                    <a href={url} title={name}>
                      {name}
                    </a>
                  </span>
                </li>
              ) : (
                <li key={index}>
                  <span>{name}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/tabs/breadcrumbs.js